/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export * from './space.module';
export * from './space.component';
export * from './space-item.component';
export * from './space-item.directive';
export * from './types';
